@if (options?.length) {
  <mat-form-field appearance="outline" >
    <mat-select (selectionChange)="onOptionSelected($event)"  [(ngModel)]="optionSelect" panelClass="select-gadget">
      @for (option of options; track option) {
        <mat-option [value]="option">
          {{option.title | translate}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}
